import { render, staticRenderFns } from "./MetalAvgPrcCountTotalRpt.vue?vue&type=template&id=5b341947&scoped=true&"
import script from "./MetalAvgPrcCountTotalRpt.vue?vue&type=script&lang=js&"
export * from "./MetalAvgPrcCountTotalRpt.vue?vue&type=script&lang=js&"
import style0 from "./MetalAvgPrcCountTotalRpt.vue?vue&type=style&index=0&id=5b341947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b341947",
  null
  
)

export default component.exports